module.exports = __webpack_public_path__ + "img/tier3-happy-score.b9f3a0e.svg";